import { Network } from '../../../utils/network'
import { Events } from '../../../utils/servicesEvents'
import { Formatter } from '../formatter'
import { resolvePhoneNumber } from './resolvePhoneNumber'

import urls from './urls.json'

async function launchTransaction(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  let url = urls.launchTransaction.wallet

  let userData = await self.servicesVars.getUserData()
  let phonePrefix = await self.servicesVars.getUserCountryPrefix()
  let countryCode = await self.servicesVars.getUserCountryCode()
  phonePrefix = data.selectedCountry?.phonePrefix || phonePrefix
  countryCode = data.selectedCountry?.countryCode || countryCode

  let body = {
    ...data,
    amount: data.amount,
    firstName: userData.firstName,
    lastName: userData.lastName,
    userId: userData.reference,
    currency: /ga/i.test(countryCode) ? 'XAF' : 'XOF',
    withdrawalCode: data.withdrawalCode,
    cryptoSellingReference: data.cryptoSellingReference,
    countryCode,
  }

  const needPhoneNumber = /momo/i.test(data.src) || /momo/i.test(data.dst)
  if (needPhoneNumber) {
    if (/bj/i.test(countryCode) && !`${data.phoneNumber}`.startsWith('01')) {
      data.phoneNumber = `01${data.phoneNumber}`
    }
    const phoneNumber = `${phonePrefix}${data.phoneNumber}`
    const phoneDetails = await resolvePhoneNumber({
      phoneNumber,
      countryCode,
    })
    if (!phoneDetails.success || !phoneDetails.decoded.carrier)
      return { notLaunched: true, badPhoneNumber: true }

    body = { ...body, phoneNumber, operator: phoneDetails.decoded.carrier }
  }
  if (
    body.phoneNumber &&
    body.operator?.toUpperCase() == 'ORANGE' &&
    /momo/i.test(data.src)
  ) {
    const fees = await calculateFee(body)
    Events.dispatchEvent('finish_loading')
    await new Promise(r => setTimeout(r, 500))
    const otpCode = await requestOtpCode(countryCode, fees)
    if (!otpCode) return { notLaunched: true, otpNotFilled: true }
    await new Promise(r => setTimeout(r, 500))
    Events.dispatchEvent('start_loading')
    body.otp = otpCode
  }
  const response = await Network.sendPostRequest(url, body)
  return response
}

async function calculateFee(data) {
  let { amount, src, dst, bookmaker, countryCode } = data
  if (src == 'bookmaker') src = bookmaker
  if (dst == 'bookmaker') dst = bookmaker
  const serverFeeResponse = await Events.sendDataRequestResolve(
    'calculateFees',
    {
      amount,
      src,
      dst,
      countryCode,
    },
  )
  return serverFeeResponse.srcAmount
}

async function requestOtpCode(countryCode, amount) {
  const otpUssdCodes = await Events.sendDataRequestResolve('otpUssdCodes')
  if (!otpUssdCodes?.metaData || !otpUssdCodes?.metaData[countryCode]) {
    return null
  }
  const otpCodeConfig = otpUssdCodes?.metaData[countryCode]
  const prompt = await Events.sendDataRequestResolve(
    'customPrompt',
    {
      title: otpCodeConfig.text.replace(/{amount}/g, amount),
      subTitle: "Veuillez générer le code otp pour lancer l'opération",
      formFields: [
        {
          type: 'text',
          propertyName: 'otpCode',
          label: 'Code otp',
          defaultValue: '',
          required: true,
        },
      ],
      successText: 'Continuer',
    },
    9999999999,
  )
  console.log(prompt)
  if (!prompt.accepted) return null
  return `${prompt.data.otpCode}`.trim()
}

function parseResponse(response) {
  if (response?.notLaunched) {
    return {
      ...response,
      success: false,
    }
  }
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
    }
  }
  if (response && response.status.code === 400) {
    return {
      success: false,
      reason: response?.response?.error?.error || 'unknown',
    }
  }
  if (response === null || response.status.code === 404) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { launchTransaction }
